export default __webpack_public_path__ + "static/modal-close-button-0f1b111c597d7f28e41fa6af5adc6771.png";